// extracted by mini-css-extract-plugin
module.exports = {"root":"NavBar_root__yosSq","slide-in":"NavBar_slide-in__2oo_N"};